var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDirectoryIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.756 7.403a1.756 1.756 0 0 0-1.51-.822H5.32c-.69 0-1.319.389-1.6.991L.035 15.296c.139.566.667.988 1.296.988H16.15c.633 0 1.212-.358 1.495-.925l3.184-6.382a1.61 1.61 0 0 0-.073-1.574Z",
  fill: "#C1C4D8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.97 6.384c.281-.602.91-.991 1.6-.991h13.115V3.715c0-.691-.584-1.254-1.3-1.254H8.736a.041.041 0 0 1-.022-.005L7.347.542A1.314 1.314 0 0 0 6.276 0H1.301C.583 0 0 .563 0 1.254V12.61l2.97-6.226Z",
  fill: "#C1C4D8"
})));
export { SvgDirectoryIcon as ReactComponent };
export default __webpack_public_path__ + "df32e9da54d612ae635f71557dd9f6c0.svg";